import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.svg';
const _withScopeId = n => (_pushScopeId("data-v-75bb1afd"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "footer-main total-center" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title total-center" }, "Nova Voice Bot", -1));
const _hoisted_3 = { class: "details" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "logo total-center" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: _imports_0,
        alt: "logo"
    })
], -1));
const _hoisted_5 = { class: "sitemap total-center" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "center-start" }, "Site Map", -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("a", {
        href: "/#features",
        title: "Features"
    }, " Features ")
], -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("a", {
        href: "https://github.com/YacineSteeve/nova-voicebot-api#readme",
        target: "_blank",
        title: "APi Documentation"
    }, " API Documentation ")
], -1));
const _hoisted_9 = { class: "registration total-center" };
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "center-start" }, "Try Nova now !", -1));
const _hoisted_11 = { class: "contact total-center" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "center-start" }, "Contact me", -1));
const _hoisted_13 = { class: "socials" };
const _hoisted_14 = {
    id: "github",
    href: "https://github.com/YacineSteeve",
    target: "_blank",
    title: "GitHub"
};
const _hoisted_15 = {
    id: "linkedin",
    href: "https://www.linkedin.com/in/yacine-boukari-585465226/",
    target: "_blank",
    title: "LinkedIn"
};
const _hoisted_16 = {
    id: "instagram",
    href: "https://www.instagram.com/yacine.b_612/",
    target: "_blank",
    title: "Instagram"
};
const _hoisted_17 = {
    id: "mail",
    href: "mailto:steeveboukari9@gmail.com",
    target: "_blank",
    title: "Mail"
};
const _hoisted_18 = {
    id: "whatsapp",
    href: "https://wa.me/33753038294",
    target: "_blank",
    title: "Whatsapp"
};
const _hoisted_19 = {
    id: "facebook",
    href: "https://www.facebook.com/yacine.boukari.315/",
    target: "_blank",
    title: "Facebook"
};
const _hoisted_20 = { class: "terms-and-conditions total-center" };
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "center-start" }, null, -1));
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "footer-bottom total-center" }, " © Copyright 2023 - Yacine BOUKARI - Nova Voice Bot ", -1));
import { POLICIES_NAMES } from '@/lib/policies';
import FooterLoginForm from '@/components/FooterLoginForm.vue';
import LegalStuffToasted from '@/components/LegalStuffToasted.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FooterSection',
    setup(__props) {
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock("footer", null, [
                _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                    _createVNode(_component_router_link, {
                                        to: "/",
                                        title: "Home"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(" Home ")
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _hoisted_7,
                                _hoisted_8,
                                _createElementVNode("li", null, [
                                    _createVNode(_component_router_link, {
                                        to: "/contact",
                                        title: "Support"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(" Support ")
                                        ]),
                                        _: 1
                                    })
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _hoisted_10,
                            _createVNode(FooterLoginForm)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("a", _hoisted_14, [
                                    _createVNode(_component_v_icon, {
                                        name: "fa-github",
                                        scale: "2"
                                    })
                                ]),
                                _createElementVNode("a", _hoisted_15, [
                                    _createVNode(_component_v_icon, {
                                        name: "fa-linkedin",
                                        scale: "2"
                                    })
                                ]),
                                _createElementVNode("a", _hoisted_16, [
                                    _createVNode(_component_v_icon, {
                                        name: "fa-instagram",
                                        scale: "2"
                                    })
                                ]),
                                _createElementVNode("a", _hoisted_17, [
                                    _createVNode(_component_v_icon, {
                                        name: "fa-envelope",
                                        scale: "2"
                                    })
                                ]),
                                _createElementVNode("a", _hoisted_18, [
                                    _createVNode(_component_v_icon, {
                                        name: "fa-whatsapp",
                                        scale: "2"
                                    })
                                ]),
                                _createElementVNode("a", _hoisted_19, [
                                    _createVNode(_component_v_icon, {
                                        name: "fa-facebook-f",
                                        scale: "2"
                                    })
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                    _createVNode(LegalStuffToasted, {
                                        "policy-name": _unref(POLICIES_NAMES).TERMS_OF_USE
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(" Terms and Conditions ")
                                        ]),
                                        _: 1
                                    }, 8, ["policy-name"])
                                ]),
                                _createElementVNode("li", null, [
                                    _createVNode(LegalStuffToasted, {
                                        "policy-name": _unref(POLICIES_NAMES).PRIVACY_POLICY
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(" Privacy Policy ")
                                        ]),
                                        _: 1
                                    }, 8, ["policy-name"])
                                ]),
                                _createElementVNode("li", null, [
                                    _createVNode(LegalStuffToasted, {
                                        "policy-name": _unref(POLICIES_NAMES).COOKIE_POLICY
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(" Cookie Policy ")
                                        ]),
                                        _: 1
                                    }, 8, ["policy-name"])
                                ])
                            ])
                        ])
                    ])
                ]),
                _hoisted_22
            ]));
        };
    }
});
